
<div>
  <img
    id="six-arts-logo"
    class="top-padding"
    src="assets/images/six_arts_logo_long.png"
  />

  <div style="text-align: left;">
    <p id="back-link">
      <a routerLink="../">返回</a>
    </p>
  </div>
</div>
<hr />
<!-- <label class="switch">
  <input type="checkbox" id="manageToggle" onclick="checkToggle()" checked>
  <span class="slider round"></span>
</label> -->



<!-- <button (click)="courseService.getDate()">TEST</button> -->
<!-- {{course$.last_update}} -->



<br />
<div style="background-color: rgb(219, 212, 200); padding: 2%;">

  <div class="container" >

    <h4>六藝學坊隸屬於非牟利機構社會企業有限公司，成立於2010年4月，位於北角英皇道60號一樓A室，是一個二千多呎的，有4個教室，列入香港學術及職業資歷評審局資歷名冊，可提供不同課程及護理員訓練證書課程。
      對於大半生都忙於工作、養家及照顧家庭，現可騰出空間來思考或培養自己興趣和喜好的機會。六藝學坊提供多元化興趣班課程，例如：運動、舞蹈、瑜伽、書法、唱歌、繪畫等和不同的工作坊，過程中既可自娛又可提升自己的個人質素，為自己下半場的生活灌注一股嶄新的力量。</h4>
  </div>
</div>

<img
  class="rounded mx-auto d-block img-thumbnail"
  src="assets/images/front.jpg">

<br />

<!-- <h3 style="text-align: center; border: red solid 3px; margin-top: 30px;">新班介紹: LIVE BAND齊齊來夾歌, 逢星期三上午11:00至12:30</h3> -->
<div class="iframe-container">
  <iframe class="responsive-iframe" src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fwatch%2F%3Fv%3D292211878478622&show_text=true&appId" width="80%" height="auto" style="max-height:4000px;border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" data-show-text="true"  allow="encrypted-media" allowFullScreen="true"></iframe>
</div>
<br />

<!-- <div class="row"> -->
  <h3>課程一覽</h3>   <button class="reg btn btn-primary mr-2" style="display: inline-block;" onclick="window.open('https://forms.gle/1DRg8SS4LsdQrs7R8','_blank')"> 報名</button>


<!-- </div> -->
<p>最後更新日期: 26/04/2021</p>
<br />
<p *ngIf="user">Logged in as: {{ user?.email }}</p>

<div *ngIf="user">

  <button class="btn btn-primary mr-2" (click)="logout()">Logout</button>
  <button class="mToggle" [routerLink]="['/six-arts/add']">ADD</button>
  <button class="mToggle" (click)="checkToggle()">EDIT</button>
  <button class="mToggle" (click)="checkDelete()">DELETE</button>
</div>

<div class="container">
  <div class="row" *ngFor="let record of record$ | async" >
    <div class="col-sm timetable" *ngFor="let day of weekdays; let i = index" [attr.data-index]="i">
      <h3 class="timetableTitle">{{ weekdayscn[i] }}</h3>
      <ng-container *ngFor="let course of course$ | async">
        <div
          [style.background-color]="[course.color]"
          class="courseDetail"
          *ngIf="course.day == day && manage==false && delete==false"
          [routerLink]="['/six-arts/', record.id, course.id]"
          fragment="six-arts-logo"
        >
          <p class="timetableTxt">{{ course.id }}</p>
          <p class="timetableTxt">{{ course.name }}</p>
          <p class="timetableTxt">{{ course.times }} - {{ course.timee }}</p>
        </div>
        <div
          [style.background-color]="[course.color]"
          class="deleteCourseDetail"
          *ngIf="course.day == day && delete"
          (click)="courseService.deleteCourse(course.id)"
          fragment="six-arts-logo"
        >
          <p class="timetableTxt">{{ course.id }}</p>
          <p class="timetableTxt">{{ course.name }}</p>
          <p class="timetableTxt">{{ course.times }} - {{ course.timee }}</p>
        </div>
        <div
          [style.background-color]="[course.color]"

          class="editCourseDetail"
          *ngIf="course.day == day && manage"
          [routerLink]="['/six-arts/manage/', record.id, course.id]"
          fragment="six-arts-logo"
        >
          <p class="timetableTxt">{{ course.id }}</p>
          <p class="timetableTxt">{{ course.name }}</p>
          <p class="timetableTxt">{{ course.times }} - {{course.timee }}</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<hr>



<div class="container">
  <div class="row">
    <div id="facebook">
      <a href="https://www.facebook.com/SixArtsSchool">
        <i class="fab fa-facebook-square"></i>
      </a>
    </div>

    <div id="instagram">
      <a href="https://www.instagram.com/sixartacademy/">
        <i class="fab fa-instagram"></i>
      </a>
    </div>
  </div>
</div>


<button class="btn btn-primary mr-2" *ngIf="!user" (click)="login()">Staff Login</button>
